import { useEffect, useState } from "react"

export function useRotatingPhrase(phrases: readonly string[], intervalMs: number, active: boolean): string {
  const [index, setIndex] = useState(0)
  const key = phrases.join("\0")

  useEffect(() => {
    setIndex(0)
  }, [active, key])

  useEffect(() => {
    if (!active || phrases.length <= 1) return
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % phrases.length)
    }, intervalMs)
    return () => window.clearInterval(id)
  }, [active, intervalMs, key, phrases.length])

  return phrases[index] ?? phrases[0] ?? ""
}
